"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const subscribable_1 = __importDefault(require("./subscribable"));
class ReportHistory extends subscribable_1.default {
    constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = 'reportHistory';
        this._rangeName = initParams.range_name;
        this._startTime = initParams.start_time;
    }
    set rangeName(value) {
        console.error('Do not set objects this way');
    }
    get rangeName() {
        return this._rangeName;
    }
    set startTime(value) {
        console.error('Do not set objects this way');
    }
    get startTime() {
        return this._startTime;
    }
}
exports.default = ReportHistory;
//# sourceMappingURL=reportHistory.js.map